import { callEndpoint } from '../backend';

export const getCountryFromLatLon = async ({ lat, lon }) => {
  const addressLookupResponse = await callEndpoint(
    callEndpoint.endpoints.reverseGeocodingAddressLookup,
    {
      lat,
      lon,
    },
  );

  const country = addressLookupResponse.results[0].address_components.find(
    (component) => component.types.includes('country'),
  ).long_name;
  return country;
};
export const getReverseGeocodingFromLatLon = async ({ lat, lon }) => {
  const addressLookupResponse = await callEndpoint(
    callEndpoint.endpoints.reverseGeocodingAddressLookup,
    {
      lat,
      lon,
    },
  );

  const locality =
    addressLookupResponse.results[0].address_components.find(
      (component) =>
        component.types.includes('locality') &&
        component.types.includes('political'),
    )?.long_name || undefined;

  const area =
    addressLookupResponse.results[0].address_components.find(
      (component) =>
        component.types.includes('administrative_area_level_1') &&
        component.types.includes('political'),
    )?.short_name || undefined;

  const locationCountry =
    addressLookupResponse.results[0].address_components.find((component) =>
      component.types.includes('country'),
    )?.long_name || undefined;

  const location = [locality, area, locationCountry]
    .filter((entry) => entry !== undefined)
    .join(', ');

  return {
    location,
    locationCountry,
  };
};

export const initialize = () => {};
